module.exports = __webpack_public_path__ + "static/BackgroundGenes1-b4ebaf041c90168de8e53795616c70ac.png";